import { Routes } from '@angular/router';
import { RegistrationFormComponent } from './registration-form/registration-form.component';
import { RegistrationSuccessComponent } from './registration-success/registration-success.component';

export const routes: Routes = [
    { path: '', component: RegistrationFormComponent },
    { path: 'success', component: RegistrationSuccessComponent }
]
